import { combineReducers } from "redux";

import { IClip } from "../api";
import { RootAction } from "../types";


function data(state: {[k: string]: IClip} = {}, action: RootAction): {[k: string]: IClip} {
    switch (action.type) {
    case 'SAVE_CLIP_SUCCESS':
        const clip = action.payload;
        if (!clip.id) {
            return state;
        }

        return {
            ...state,
            [clip.id]: clip,
        };
    
    case 'LIST_CLIPS_SUCCESS':
        const newState = {...state};
        action.payload.forEach(c => {
            if (!c.id) {
                return;
            }

            newState[c.id] = c;
        });
        return newState;

    default:
        return state;
    }
}

export const clipsReducer = combineReducers({
    data,
});

export default clipsReducer;



// WEBPACK FOOTER //
// ./src/reducers/clipsReducer.ts